import './NoUpcomingEvents.scss';

import Paragraph from 'components/TextComps/Paragraph';
import Subtitle from 'components/TextComps/Subtitle';
import exploreUpcomingEventsImg from 'images/TrackmanEvents/exploreUpcomingEvents.png';
import { useTranslation } from 'react-i18next';

export const NoUpcomingEvents = () => {
  const { t } = useTranslation();

  return (
    <div className='no-events'>
      <div className='no-events-image'>
        <img src={exploreUpcomingEventsImg} alt={t('ExploreUpcomingEvents', { ns: 'trackmanEvents' })} />
      </div>
      <div className='no-events-text'>
        <Subtitle>
          <>{t('ExcitingEventsAreOnTheWay', { ns: 'trackmanEvents' })}</>
        </Subtitle>
        <Paragraph>
          <>{t('WereWorkingOnOurNextWebinar', { ns: 'trackmanEvents' })}</>
        </Paragraph>
      </div>
    </div>
  );
};
